"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChildrenWrapper = _interopRequireDefault(require("./ChildrenWrapper"));

var _Spinner = _interopRequireDefault(require("../../elements/Spinner"));

var styles = {
  scrollbar: {
    width: '100%',
    height: '100%'
  },
  scrollbarVertical: {
    overflow: 'hidden',
    overflowY: 'auto'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden'
  }
};

var pageScrollContainer = function pageScrollContainer() {
  return navigator.userAgent.includes('Safari') ? document.body : document.documentElement;
};

var InfiniteScroller =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(InfiniteScroller, _React$PureComponent);

  function InfiniteScroller() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InfiniteScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InfiniteScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "additionLoading",
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var _this$props, onScroll, hasMore, isLoading, height, isEnoughSpace;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onScroll = _this$props.onScroll, hasMore = _this$props.hasMore, isLoading = _this$props.isLoading, height = _this$props.height;
              isEnoughSpace = height ? Array.from(_this.scroll.childNodes).reduce(function (accumulator, currentValue) {
                return accumulator + currentValue.clientHeight;
              }, 0) < height : _this.scroll.clientHeight < window.innerHeight;

              if (!isLoading && hasMore && isEnoughSpace) {
                onScroll();
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_scrollHandler",
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(distanceFromTop, innerHeightPage, documentScrollHeight) {
        var _this$props2, onScroll, hasMore, isLoading, deltaDistance, isScrolledToBottom;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, onScroll = _this$props2.onScroll, hasMore = _this$props2.hasMore, isLoading = _this$props2.isLoading, deltaDistance = _this$props2.deltaDistance;
                isScrolledToBottom = distanceFromTop + innerHeightPage + deltaDistance >= documentScrollHeight;

                if (hasMore && !isLoading && isScrolledToBottom) {
                  onScroll();
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScrollEvent", function () {
      var height = _this.props.height;

      if (height) {
        _this._scrollHandler(_this.scroll.scrollTop, _this.scroll.clientHeight, _this.scroll.scrollHeight);
      } else {
        _this._scrollHandler(window.pageYOffset, window.innerHeight, pageScrollContainer().scrollHeight);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(InfiniteScroller, [{
    key: "componentDidMount",

    /**
     * There two way for checking scroll activity - when scrollbar inside some block or inside page
     */
    value: function componentDidMount() {
      var height = this.props.height;

      if (height) {
        this.scroll.addEventListener('scroll', this.handleScrollEvent);
      } else {
        window.addEventListener('scroll', this.handleScrollEvent);
      }

      this.additionLoading();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.additionLoading();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var height = this.props.height;

      if (height) {
        this.scroll.removeEventListener('scroll', this.handleScrollEvent);
      } else {
        window.removeEventListener('scroll', this.handleScrollEvent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll,
          showLoader = _this$props3.showLoader,
          loader = _this$props3.loader,
          hasMore = _this$props3.hasMore,
          isLoading = _this$props3.isLoading,
          style = _this$props3.style,
          deltaDistance = _this$props3.deltaDistance,
          props = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "height", "onScroll", "showLoader", "loader", "hasMore", "isLoading", "style", "deltaDistance"]);
      return _react.default.createElement("div", (0, _extends2.default)({
        ref: function ref(_ref3) {
          _this2.scroll = _ref3;
        },
        style: (0, _objectSpread2.default)({}, styles.scrollbar, height ? styles.scrollbarVertical : {}, height ? {
          height: height
        } : {}, style)
      }, props), _react.default.createElement(_ChildrenWrapper.default, {
        isLoading: isLoading
      }, children), isLoading && showLoader && this.loader);
    }
  }, {
    key: "loader",
    get: function get() {
      var loader = this.props.loader;

      if (loader) {
        return typeof loader === 'function' ? loader() : loader;
      }

      return _react.default.createElement("div", {
        style: styles.loader
      }, _react.default.createElement(_Spinner.default, {
        type: "indeterminate"
      }));
    }
    /**
     * This function loads more items if current amount of them is not enough for showing scrollbar.
     */

  }]);
  return InfiniteScroller;
}(_react.default.PureComponent);

InfiniteScroller.propTypes = {
  /**
   * children: Сhildren сomponents
   */
  children: _propTypes.default.node,

  /**
   * height: The height of scrolled container
   */
  height: _propTypes.default.number,

  /**
   * showLoader: Indicates necessary of showing loading block
   */
  showLoader: _propTypes.default.bool,

  /**
   * loader: Component that overrides default loader block
   */
  loader: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),

  /**
   * hasMore: Indicates necessary of loading next part of data
   */
  hasMore: _propTypes.default.bool.isRequired,

  /**
   * onScroll: Callback that will be called when block is scrolled to the bottom
   */
  onScroll: _propTypes.default.func.isRequired,

  /**
   * isLoading: Indicates loading process
   */
  isLoading: _propTypes.default.bool,

  /**
   * style: Style object
   */
  style: _propTypes.default.object,

  /**
   * deltaDistance: An extra distance from the bottom of the scroll block
   * for early call onScroll event. Required for smoother loading of data
   */
  deltaDistance: _propTypes.default.number
};
InfiniteScroller.defaultProps = {
  height: null,
  showLoader: false,
  loader: null,
  isLoading: false,
  style: {},
  deltaDistance: 100
};
var _default = InfiniteScroller;
exports.default = _default;